import React from 'react'
import { Form } from 'formik'
import { Box } from '@chakra-ui/react'

export const FormikChakraForm = React.forwardRef((props, ref) => <Box ref={ref} as={Form} {...props} />)
